import { FULL_CATALOG_ROLLOUT_REVISION } from './iam-v2-route-contract'

export const ROUTE_SOURCE_V2 = 'v2'

// Retired administration pages stay in the historical
// backend catalog for audit, but must never be imported as active pages.
export const RETIRED_ROUTE_CODES = [
  'route.case',
  'route.case_list',
  'route.setting',
  'route.setting_detail',
  'route.permission_list',
  'route.role_list',
  'route.route_list',
  'route.legacy_role_permission_matrix'
]

// Keep these authorized pages accessible while hiding their menu entries.
const HIDDEN_MENU_ROUTE_CODES = [
  'route.order_list',
  'route.performance',
  'route.performance_list'
]

export function isFullCatalogRouteSource (snapshot) {
  return Boolean(snapshot && snapshot.route_source &&
    snapshot.route_source.mode === ROUTE_SOURCE_V2 &&
    snapshot.route_source.revision === FULL_CATALOG_ROLLOUT_REVISION)
}

function retiredRouteLookup () {
  return RETIRED_ROUTE_CODES.reduce((lookup, code) => {
    lookup[code] = true
    return lookup
  }, Object.create(null))
}

export function selectV2RouteTree (routes) {
  const retired = retiredRouteLookup()
  function visit (route) {
    if (!route || retired[route.code]) return null
    const children = (route.children || []).map(visit).filter(Boolean)
    if ((route.children || []).length && !children.length &&
        (route.component === 'Home' || route.visibility_mode === 'CHILDREN')) return null
    const selected = Object.assign({}, route, { children })
    const hiddenContainer = children.length && children.every(child => child.hidden) &&
      (route.component === 'Home' || route.visibility_mode === 'CHILDREN')
    if (HIDDEN_MENU_ROUTE_CODES.includes(route.code) || hiddenContainer) selected.hidden = true
    return selected
  }
  return (routes || []).map(visit).filter(Boolean)
}



// WEBPACK FOOTER //
// ./src/router/iam-v2-route-source.js